import { useEffect, useRef } from 'react';

export function usePrevious(value) {
  let ref = useRef();
  useEffect(() => void (ref.current = value), [value]);
  return ref.current;
}
